import React, { useState, useEffect } from 'react'

const TimeAgo = ({ date, updateInterval = 60000, className = '' }) => {
  const [timeAgo, setTimeAgo] = useState(formatTimeAgo(date))

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeAgo(formatTimeAgo(date))
    }, updateInterval)

    return () => clearInterval(interval)
  }, [date, updateInterval])

  return <span className={className}>{timeAgo}</span>
}

function formatTimeAgo(dateString) {
  const now = new Date()
  const time = new Date(dateString)
  const diffInSeconds = Math.floor((now - time) / 1000)

  if (diffInSeconds < 60) {
    return 'Just now'
  } else if (diffInSeconds < 3600) {
    const minutes = Math.floor(diffInSeconds / 60)
    return `${minutes}m ago`
  } else if (diffInSeconds < 86400) {
    const hours = Math.floor(diffInSeconds / 3600)
    return `${hours}h ago`
  } else if (diffInSeconds < 604800) {
    const days = Math.floor(diffInSeconds / 86400)
    return `${days}d ago`
  } else {
    return time.toLocaleDateString()
  }
}

export default TimeAgo